var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg66(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 700,
    height: 492,
    viewBox: "0 0 700 492",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 698,
    height: 490,
    rx: 24,
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 146,
    width: 40,
    height: 301,
    rx: 10,
    fill: "black",
    fillOpacity: 0.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 271,
    width: 40,
    height: 176,
    rx: 10,
    fill: "black",
    fillOpacity: 0.5
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 151,
    y: 215,
    width: 40,
    height: 232,
    rx: 10,
    fill: "black",
    fillOpacity: 0.5
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 202,
    y: 238,
    width: 40,
    height: 209,
    rx: 10,
    fill: "black",
    fillOpacity: 0.5
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 253,
    y: 185,
    width: 40,
    height: 262,
    rx: 10,
    fill: "#A1CF1C"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 304,
    y: 204,
    width: 40,
    height: 243,
    rx: 10,
    fill: "black",
    fillOpacity: 0.5
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 355,
    y: 168,
    width: 40,
    height: 279,
    rx: 10,
    fill: "black",
    fillOpacity: 0.5
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 406,
    y: 140,
    width: 40,
    height: 307,
    rx: 10,
    fill: "#808080"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 457,
    y: 254,
    width: 40,
    height: 193,
    rx: 10,
    fill: "black",
    fillOpacity: 0.5
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 508,
    y: 226,
    width: 40,
    height: 221,
    rx: 10,
    fill: "black",
    fillOpacity: 0.5
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 559,
    y: 168,
    width: 40,
    height: 279,
    rx: 10,
    fill: "black",
    fillOpacity: 0.5
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 610,
    y: 204,
    width: 40,
    height: 243,
    rx: 10,
    fill: "black",
    fillOpacity: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M244.76 53V38.93H239.12V35.84H254.18V38.93H248.54V53H244.76ZM254.503 53V35.84H261.913C263.453 35.84 264.783 36.09 265.903 36.59C267.023 37.07 267.883 37.77 268.483 38.69C269.103 39.61 269.413 40.72 269.413 42.02C269.413 43.3 269.103 44.4 268.483 45.32C267.883 46.24 267.023 46.94 265.903 47.42C264.783 47.9 263.453 48.14 261.913 48.14H256.603L258.283 46.49V53H254.503ZM265.663 53L261.253 46.76H265.333L269.743 53H265.663ZM258.283 46.94L256.903 45.17H261.643C262.963 45.17 263.953 44.9 264.613 44.36C265.273 43.8 265.603 43.02 265.603 42.02C265.603 41.02 265.273 40.25 264.613 39.71C263.953 39.17 262.963 38.9 261.643 38.9H256.903L258.283 37.16V46.94ZM268.445 53L276.245 35.84H279.995L287.765 53H284.015L277.475 37.76H278.735L272.135 53H268.445ZM272.315 49.28L273.335 46.4H282.275L283.295 49.28H272.315ZM287.818 53V35.84H290.938L301.288 48.38H299.878V35.84H303.628V53H300.508L290.158 40.46H291.598V53H287.818ZM319.143 47.93C319.143 49.01 318.843 49.95 318.243 50.75C317.663 51.55 316.833 52.18 315.753 52.64C314.673 53.08 313.353 53.3 311.793 53.3C310.453 53.3 309.133 53.12 307.833 52.76C306.553 52.4 305.523 51.93 304.743 51.35L306.153 48.41C306.873 48.95 307.753 49.38 308.793 49.7C309.833 50.02 310.893 50.18 311.973 50.18C313.253 50.18 314.143 49.99 314.643 49.61C315.143 49.23 315.393 48.78 315.393 48.26C315.393 47.78 315.203 47.4 314.823 47.12C314.463 46.84 313.973 46.62 313.353 46.46C312.753 46.28 312.093 46.12 311.373 45.98C310.653 45.82 309.933 45.64 309.213 45.44C308.493 45.24 307.833 44.96 307.233 44.6C306.633 44.24 306.143 43.76 305.763 43.16C305.403 42.56 305.223 41.8 305.223 40.88C305.223 39.82 305.523 38.89 306.123 38.09C306.723 37.29 307.563 36.67 308.643 36.23C309.743 35.79 311.033 35.57 312.513 35.57C313.573 35.57 314.633 35.69 315.693 35.93C316.773 36.15 317.713 36.52 318.513 37.04L317.223 39.98C316.463 39.48 315.663 39.14 314.823 38.96C314.003 38.76 313.193 38.66 312.393 38.66C311.193 38.66 310.323 38.85 309.783 39.23C309.263 39.61 309.003 40.09 309.003 40.67C309.003 41.15 309.183 41.53 309.543 41.81C309.923 42.09 310.413 42.32 311.013 42.5C311.613 42.66 312.273 42.81 312.993 42.95C313.733 43.09 314.453 43.27 315.153 43.49C315.873 43.69 316.533 43.97 317.133 44.33C317.753 44.67 318.243 45.13 318.603 45.71C318.963 46.29 319.143 47.03 319.143 47.93ZM320.284 53V35.84H327.694C329.234 35.84 330.564 36.09 331.684 36.59C332.804 37.07 333.664 37.77 334.264 38.69C334.884 39.61 335.194 40.72 335.194 42.02C335.194 43.32 334.884 44.44 334.264 45.38C333.664 46.3 332.804 47.01 331.684 47.51C330.564 47.99 329.234 48.23 327.694 48.23H322.384L324.064 46.49V53H320.284ZM324.064 46.94L322.684 45.17H327.424C328.744 45.17 329.734 44.9 330.394 44.36C331.054 43.8 331.384 43.02 331.384 42.02C331.384 41.02 331.054 40.25 330.394 39.71C329.734 39.17 328.744 38.9 327.424 38.9H322.684L324.064 37.16V46.94ZM344.821 53.3C343.001 53.3 341.371 52.92 339.931 52.16C338.511 51.38 337.391 50.32 336.571 48.98C335.751 47.64 335.341 46.12 335.341 44.42C335.341 42.72 335.751 41.21 336.571 39.89C337.391 38.55 338.511 37.5 339.931 36.74C341.371 35.96 342.991 35.57 344.791 35.57C346.611 35.57 348.231 35.96 349.651 36.74C351.091 37.5 352.221 38.55 353.041 39.89C353.861 41.21 354.271 42.72 354.271 44.42C354.271 46.12 353.861 47.64 353.041 48.98C352.221 50.32 351.091 51.38 349.651 52.16C348.231 52.92 346.621 53.3 344.821 53.3ZM344.791 50.09C345.891 50.09 346.861 49.85 347.701 49.37C348.561 48.87 349.231 48.19 349.711 47.33C350.191 46.47 350.431 45.5 350.431 44.42C350.431 43.32 350.181 42.35 349.681 41.51C349.201 40.65 348.541 39.98 347.701 39.5C346.861 39.02 345.901 38.78 344.821 38.78C343.741 38.78 342.771 39.02 341.911 39.5C341.051 39.98 340.371 40.65 339.871 41.51C339.391 42.35 339.151 43.32 339.151 44.42C339.151 45.5 339.391 46.47 339.871 47.33C340.371 48.19 341.051 48.87 341.911 49.37C342.771 49.85 343.731 50.09 344.791 50.09ZM355.65 53V35.84H363.06C364.6 35.84 365.93 36.09 367.05 36.59C368.17 37.07 369.03 37.77 369.63 38.69C370.25 39.61 370.56 40.72 370.56 42.02C370.56 43.3 370.25 44.4 369.63 45.32C369.03 46.24 368.17 46.94 367.05 47.42C365.93 47.9 364.6 48.14 363.06 48.14H357.75L359.43 46.49V53H355.65ZM366.81 53L362.4 46.76H366.48L370.89 53H366.81ZM359.43 46.94L358.05 45.17H362.79C364.11 45.17 365.1 44.9 365.76 44.36C366.42 43.8 366.75 43.02 366.75 42.02C366.75 41.02 366.42 40.25 365.76 39.71C365.1 39.17 364.11 38.9 362.79 38.9H358.05L359.43 37.16V46.94ZM375.208 53V38.93H369.568V35.84H384.628V38.93H378.988V53H375.208ZM381.137 53L388.937 35.84H392.687L400.457 53H396.707L390.167 37.76H391.427L384.827 53H381.137ZM385.007 49.28L386.027 46.4H394.967L395.987 49.28H385.007ZM402.606 53V38.93H396.966V35.84H412.026V38.93H406.386V53H402.606ZM412.349 53V35.84H416.129V53H412.349ZM427.013 53.3C425.193 53.3 423.563 52.92 422.123 52.16C420.703 51.38 419.583 50.32 418.763 48.98C417.943 47.64 417.533 46.12 417.533 44.42C417.533 42.72 417.943 41.21 418.763 39.89C419.583 38.55 420.703 37.5 422.123 36.74C423.563 35.96 425.183 35.57 426.983 35.57C428.803 35.57 430.423 35.96 431.843 36.74C433.283 37.5 434.413 38.55 435.233 39.89C436.053 41.21 436.463 42.72 436.463 44.42C436.463 46.12 436.053 47.64 435.233 48.98C434.413 50.32 433.283 51.38 431.843 52.16C430.423 52.92 428.813 53.3 427.013 53.3ZM426.983 50.09C428.083 50.09 429.053 49.85 429.893 49.37C430.753 48.87 431.423 48.19 431.903 47.33C432.383 46.47 432.623 45.5 432.623 44.42C432.623 43.32 432.373 42.35 431.873 41.51C431.393 40.65 430.733 39.98 429.893 39.5C429.053 39.02 428.093 38.78 427.013 38.78C425.933 38.78 424.963 39.02 424.103 39.5C423.243 39.98 422.563 40.65 422.063 41.51C421.583 42.35 421.343 43.32 421.343 44.42C421.343 45.5 421.583 46.47 422.063 47.33C422.563 48.19 423.243 48.87 424.103 49.37C424.963 49.85 425.923 50.09 426.983 50.09ZM437.842 53V35.84H440.962L451.312 48.38H449.902V35.84H453.652V53H450.532L440.182 40.46H441.622V53H437.842Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg66);
export default __webpack_public_path__ + "static/media/66.ba9f368e56be11986ae56bd20de52025.svg";
export { ForwardRef as ReactComponent };